import http from '@/js/http';
import { IProfileUpdateRequest } from './request.interface';

export const ProfileService = {
    async update(profileId: string | number, payload: IProfileUpdateRequest) {
        const { data } = await http.put(`/profiles/${profileId}`, payload);
        return data;
    },
};
